import { createFileRoute, redirect } from '@tanstack/react-router';
import { type z } from 'zod';

import { agentConfigurationSearchSchema } from '@apps/web/components/automations/agent_configuration_search';

/** Keep old bookmarks working while `/routines` is canonical. */
export function handleAutomationsBeforeLoad({
    search,
}: {
    readonly search: z.infer<typeof agentConfigurationSearchSchema>;
}): void {
    if (search.automation_id !== undefined) {
        throw redirect({
            to: '/routines/$routineId',
            params: { routineId: search.automation_id },
            search: {},
            replace: true,
        });
    }
    throw redirect({
        to: '/routines',
        search: {},
        replace: true,
    });
}

export const Route = createFileRoute('/_app/(main)/automations/')({
    validateSearch: agentConfigurationSearchSchema,
    beforeLoad: handleAutomationsBeforeLoad,
});
